import { render, staticRenderFns } from "./CNotificationsFromStore.vue?vue&type=template&id=2e7b245c&"
import script from "./CNotificationsFromStore.vue?vue&type=script&lang=js&"
export * from "./CNotificationsFromStore.vue?vue&type=script&lang=js&"
import style0 from "./CNotificationsFromStore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
